import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const MapPinOutlineIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 65 80" {...props}>
      <path
        fill={fill}
        d="M32.5,21.2247887 C28.2439008,21.2247887 24.7818248,24.7030986 24.7818248,28.9791549 C24.7818248,33.256338 28.2439008,36.7346479 32.5,36.7346479 C36.7572207,36.7346479 40.2192967,33.256338 40.2192967,28.9791549 C40.2192967,24.7030986 36.7572207,21.2247887 32.5,21.2247887 M32.5,43.2653521 C24.6607026,43.2653521 18.2816005,36.8574648 18.2816005,28.9791549 C18.2816005,21.1030986 24.6607026,14.6940845 32.5,14.6940845 C40.3404189,14.6940845 46.719521,21.1030986 46.719521,28.9791549 C46.719521,36.8574648 40.3404189,43.2653521 32.5,43.2653521 M32.5,6.53070423 C18.1638428,6.53070423 6.4991028,18.2490141 6.4991028,32.6535211 C6.4991028,43.7892958 23.5874254,63.2315493 32.5,72.1746479 C41.4114531,63.228169 58.5008972,43.7780282 58.5008972,32.6535211 C58.5008972,18.2490141 46.8372787,6.53070423 32.5,6.53070423 M32.5,80 C31.6958832,80 30.8906449,79.7014085 30.264847,79.1053521 C29.9597985,78.8146479 22.71714,71.8952113 15.3578453,62.8461972 C5.16788019,50.315493 0,40.1566197 0,32.6535211 C0,14.6478873 14.5795231,0 32.5,0 C50.4204769,0 65,14.6478873 65,32.6535211 C65,40.1566197 59.8332413,50.315493 49.6421547,62.8461972 C42.2839815,71.8952113 35.041323,78.8146479 34.7362745,79.1053521 C34.1093551,79.7014085 33.3052383,80 32.5,80"
      />
    </Icon>
  );
};

MapPinOutlineIcon.propTypes = {
  fill: PropTypes.string,
};

export default MapPinOutlineIcon;
